// The values are tied to values created in the CMS
export const CTA_OVERRIDES = {
  STICKY_FORM: 'Lead Gen Form',
  ADSTUDIO_LOGIN: 'AdStudio Login',
};
